import React, { useEffect, useRef, useState } from 'react';
import { COLORS, FONT } from '../../theme';

const estiloCampo = {
  width: '100%', border: `1.5px solid ${COLORS.border}`, borderRadius: 6, padding: '6px 8px',
  fontSize: 12.5, fontFamily: FONT, boxSizing: 'border-box'
};

// Cabeçalho de tabela com filtro embutido, estilo planilha: clica no título, abre um painel
// flutuante com o filtro daquela coluna (lista de opções, texto, número ou intervalo de
// data/valor), sem precisar de uma barra de filtros separada acima da tabela.
export default function ThFilter({ label, tipo = 'texto', value, onChange, options = [], width, align = 'left' }) {
  const [open, setOpen] = useState(false);
  const [dropPos, setDropPos] = useState({ top: 0, left: 0 });
  const [rascunho, setRascunho] = useState(value);
  const ref = useRef(null);

  useEffect(() => { setRascunho(value); }, [value, open]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const vazio = tipo === 'data' || tipo === 'valor'
    ? !(value && (value.de || value.ate))
    : !value;
  const ativo = !vazio;

  const abrir = () => {
    if (!open && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const left = Math.min(rect.left, window.innerWidth - 220);
      setDropPos({ top: rect.bottom + 2, left: Math.max(0, left) });
    }
    setOpen(o => !o);
  };

  const aplicar = () => { onChange(rascunho); setOpen(false); };
  const limpar = () => { const vazioVal = (tipo === 'data' || tipo === 'valor') ? {} : ''; onChange(vazioVal); setRascunho(vazioVal); setOpen(false); };
  const onKeyDown = (e) => { if (e.key === 'Enter') aplicar(); };

  return (
    <th ref={ref} onClick={abrir} style={{
      position: 'relative', padding: '10px 12px', fontWeight: 700, fontSize: 12,
      textAlign: align, whiteSpace: 'nowrap', cursor: 'pointer', userSelect: 'none',
      background: ativo ? COLORS.primaryBg : COLORS.bg, color: ativo ? COLORS.primary : COLORS.text,
      width, borderBottom: `2px solid ${COLORS.border}`
    }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
        {label}
        <span style={{ fontSize: 10, opacity: 0.8 }}>{ativo ? '▼' : '⌄'}</span>
      </span>

      {open && (
        <div onClick={e => e.stopPropagation()} style={{
          position: 'fixed', top: dropPos.top, left: dropPos.left, zIndex: 9999,
          background: '#fff', border: `1px solid ${COLORS.border}`, borderRadius: 8,
          boxShadow: '0 6px 20px rgba(0,0,0,0.18)', minWidth: 200, padding: 10,
          fontWeight: 400, textTransform: 'none', color: COLORS.text
        }}>
          {tipo === 'select' && (
            <div style={{ maxHeight: '55vh', overflowY: 'auto' }}>
              <div onClick={() => { onChange(''); setOpen(false); }} style={{
                padding: '7px 10px', cursor: 'pointer', fontSize: 13, borderRadius: 6,
                fontWeight: !value ? 700 : 400, background: !value ? COLORS.primaryBg : 'transparent',
                color: !value ? COLORS.primary : COLORS.text
              }}>(Todas)</div>
              {options.map(opt => (
                <div key={opt.value} onClick={() => { onChange(opt.value); setOpen(false); }} style={{
                  padding: '7px 10px', cursor: 'pointer', fontSize: 13, borderRadius: 6,
                  fontWeight: value === opt.value ? 700 : 400,
                  background: value === opt.value ? COLORS.primaryBg : 'transparent',
                  color: value === opt.value ? COLORS.primary : COLORS.text
                }}>{opt.label}</div>
              ))}
            </div>
          )}

          {(tipo === 'texto' || tipo === 'numero') && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input autoFocus type={tipo === 'numero' ? 'number' : 'text'} value={rascunho || ''} onKeyDown={onKeyDown}
                onChange={e => setRascunho(e.target.value)} style={estiloCampo} placeholder="Filtrar..." />
              <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                <button onClick={limpar} style={{ fontSize: 11, color: COLORS.textMid, background: 'none', border: 'none', cursor: 'pointer' }}>Limpar</button>
                <button onClick={aplicar} style={{ fontSize: 11, fontWeight: 600, color: '#fff', background: COLORS.primary, border: 'none', borderRadius: 5, padding: '5px 10px', cursor: 'pointer' }}>Aplicar</button>
              </div>
            </div>
          )}

          {tipo === 'data' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input type="date" value={rascunho?.de || ''} onChange={e => setRascunho(r => ({ ...r, de: e.target.value }))} style={estiloCampo} />
              <input type="date" value={rascunho?.ate || ''} onChange={e => setRascunho(r => ({ ...r, ate: e.target.value }))} style={estiloCampo} />
              <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                <button onClick={limpar} style={{ fontSize: 11, color: COLORS.textMid, background: 'none', border: 'none', cursor: 'pointer' }}>Limpar</button>
                <button onClick={aplicar} style={{ fontSize: 11, fontWeight: 600, color: '#fff', background: COLORS.primary, border: 'none', borderRadius: 5, padding: '5px 10px', cursor: 'pointer' }}>Aplicar</button>
              </div>
            </div>
          )}

          {tipo === 'valor' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input type="number" step="0.01" placeholder="Mínimo R$" value={rascunho?.de ?? ''} onKeyDown={onKeyDown}
                onChange={e => setRascunho(r => ({ ...r, de: e.target.value }))} style={estiloCampo} />
              <input type="number" step="0.01" placeholder="Máximo R$" value={rascunho?.ate ?? ''} onKeyDown={onKeyDown}
                onChange={e => setRascunho(r => ({ ...r, ate: e.target.value }))} style={estiloCampo} />
              <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                <button onClick={limpar} style={{ fontSize: 11, color: COLORS.textMid, background: 'none', border: 'none', cursor: 'pointer' }}>Limpar</button>
                <button onClick={aplicar} style={{ fontSize: 11, fontWeight: 600, color: '#fff', background: COLORS.primary, border: 'none', borderRadius: 5, padding: '5px 10px', cursor: 'pointer' }}>Aplicar</button>
              </div>
            </div>
          )}
        </div>
      )}
    </th>
  );
}
